import { IntegratedIReckonHotel } from '@era/locations-sdk';
import { createActionGroup, props } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const IReckonIntegratedHotelResolverActions = createActionGroup({
  source: 'IReckon integrated hotel resolver',
  events: {
    'Integration requested': props<{ locationUniqueId: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const IReckonIntegratedHotelApiActions = createActionGroup({
  source: 'IReckon integrated hotel API',
  events: {
    'Integrations loaded': props<{ hotels: IntegratedIReckonHotel[] }>(),
    'Integrations loaded error': props<{ error: ErrorModel }>(),
    'Integrations updated': props<{ hotel: IntegratedIReckonHotel }>(),
    'Integrations updated error': props<{ hotel: IntegratedIReckonHotel; error: ErrorModel }>(),
    'Integrations added': props<{ hotel: IntegratedIReckonHotel }>(),
    'Integrations added error': props<{ hotel: IntegratedIReckonHotel; error: ErrorModel }>(),
  },
});

// ============================================================================
// VIEW ACTIONS (Group - using createActionGroup)
// ============================================================================

export const IReckonIntegratedHotelContainerActions = createActionGroup({
  source: 'IReckon integrated hotel container',
  events: {
    'Integration updated': props<{ hotel: IntegratedIReckonHotel }>(),
  },
});
